import React, { useState } from "react";

function ScrollToTopButton() {
    const [visible, setVisible] = useState(false);

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true);
        } else if (scrolled <= 300) {
            setVisible(false);
        }
    };

    const ScrollToTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    };

    window.addEventListener("scroll", toggleVisible);

    return (
        <>
            <div className="go-top-div" style={{ display: visible ? "inline" : "none" }} onClick={() => ScrollToTop()}>
                <a className="go-top-anchor">
                    <span className="go-top"></span>
                </a>
            </div>
        </>
    );
}

export default ScrollToTopButton;
